module.exports = __webpack_public_path__ + "img/icon_map_61_on_010.b258f20b.png";